import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';
import { FaSearch, FaTimes } from 'react-icons/fa';

export const Sticky = styled.div`
  width: 100%;
  position: sticky;
  top: ${({ bound }) => `${bound}px`};
  z-index: 2;
`;

export const HeaderBg = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 10px 20px;
  margin-top: -1px; /* margin-top to account for small spacing rendering issue */
  z-index: 2;

  @media ${sizes.largeDesktop} {
    padding: 10px 40px;
  }

  @media ${sizes.extraLargeDesktop} {
    padding: 10px 80px;
  }
`;

export const InputContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding-bottom: ${th('space.5')}px;
  position: relative;

  @media ${sizes.tabletLandscape} {
    width: 450px;
  }
`;

export const TextInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 5px;
  margin: 0;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${th('colors.white')};
  font-size: 16px;
  color: ${th('colors.white')};
  background-color: transparent;

  ::placeholder {
    color: #e5e5e5;
  }

  :focus {
    outline: none;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 10px;
`;

export const SearchIcon = styled(FaSearch)`
  position: relative;
  color: ${th('colors.white')};
`;

export const CancelIcon = styled(FaTimes)`
  position: relative;
  cursor: pointer;
  color: ${th('colors.white')};
`;
